import React, { useRef, useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ICON_SAVE, ICON_CANCEL } from '../../extras/icons';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveUnitsAction, updateUnitsAction } from '../../../actions/unitsActions';
import { listServersAction } from '../../../actions/serversActions';
import { Formik } from 'formik';
import ButtonSpinner from '../../layout/ButtonSpinner';
import * as yup from 'yup';
import { setLocale } from 'yup';
import profiles from '../../../data/profiles';
//Función principal
const UnitForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refDescription = useRef();
    //Datos iniciales
    const initialData = {
        descripcion: '',
        email: '',
        fuero: '',
        perfil: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const unitsLoading = useSelector( state => state.units.loadingSave );
    const errorSave = useSelector( state => state.units.errorSave );
    const isEdit = useSelector( state => state.units.isEdit );
    const unitSelected = useSelector( state => state.units.unitSelected );
    const servers = useSelector( state => state.servers.servers );
    //Inicializo el state local
    const [ unit, setUnit ] = useState(initialData);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && unitSelected){
            setUnit({
                ...unitSelected,
                fuero: unitSelected.fuero ? unitSelected.fuero.id : '',
                perfil: unitSelected.perfil ? unitSelected.perfil.id : ''
            });
        }else{
            setUnit(initialData);
        }
    }, [isEdit, unitSelected, show])
    //Manejo de cambios
    const handleChange = e => {
        setUnit({
            ...unit,
            [e.target.name]: e.target.value
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Armo el objeto de datos
        let data = {
            descripcion: values.descripcion,
            email: values.email,
            fuero: {
                id: values.fuero
            },
            perfil: {
                id: values.perfil
            },
            activo: 1
        }
        //Verifico si es edición o alta
        if(unit.id){
            //Agrego el ID
            data = {
                id: unit.id,
                ...data
            }
            //Es edición
            dispatch( updateUnitsAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveUnitsAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Me fijo si están cargados los fueros
        if(!servers){
            const params = {
                search: 'activo:1',
                sort: 'descripcion:asc'
            }
            dispatch( listServersAction(params) );
        }
        //Pongo el foco en el primer campo
        refDescription.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setUnit(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        descripcion: yup.string().required(),
        fuero: yup.number().required(),
        email: yup.string().email().nullable(),
        perfil: yup.number().required()
    });
    //Renderizo
    return (
        <Modal show={show} onHide={handleCloseForm} onShow={handleOnShow} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Unit&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...unit }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-12">
                                    <label htmlFor="descripcion">Descripción</label>
                                    <Form.Control
                                        id="descripcion"
                                        className="form-control" 
                                        autoFocus 
                                        name="descripcion" 
                                        type="text" 
                                        value={ values.descripcion }
                                        onChange={handleChange}
                                        ref={refDescription}
                                        isInvalid={!!errors.descripcion}
                                        disabled={ unitsLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.descripcion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="fuero">Fuero</label>
                                    <Form.Control
                                        as="select"
                                        id="fuero"
                                        className="form-control"  
                                        name="fuero" 
                                        value={ values.fuero }
                                        onChange={handleChange}
                                        isInvalid={!!errors.fuero}
                                        disabled={ unitsLoading }
                                    >
                                        <option value="">Seleccione el Fuero</option>
                                        {
                                            servers ? (
                                                servers.map(server => (
                                                    <option value={server.id} key={`uf${server.id}`}>
                                                        { server.descripcion }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fuero }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="email">Email</label>
                                    <Form.Control
                                        id="email"
                                        className="form-control"  
                                        name="email" 
                                        type="text" 
                                        value={ values.email }
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                        disabled={ unitsLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.email }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="perfil">Perfil</label>
                                    <Form.Control
                                        as="select"
                                        id="perfil"
                                        className="form-control"  
                                        name="perfil" 
                                        value={ values.perfil }
                                        onChange={handleChange}
                                        isInvalid={!!errors.perfil}
                                        disabled={ unitsLoading }
                                    >
                                        <option value="">Seleccione el Perfil</option>
                                        {
                                            profiles.map(profile => (
                                                <option value={profile.id} key={`up${profile.id}`}>
                                                    { profile.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.perfil }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                unitsLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ unitsLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ unitsLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default UnitForm;